/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{padding-left:24px;margin-bottom:0}.mat-dialog-title[_ngcontent-%COMP%]{margin-left:24px;margin-top:24px}\n/*# sourceMappingURL=activity-dialog.component.css.map*/"];
export { styles as styles };
